var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonSocialAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#648586"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.209 28.5719H29.1959V37.5712H25.1783V28.5719H21.8839V24.8757H25.1783V22.0232C25.1783 18.8092 27.1067 17.0013 30.0395 17.0013C31.4457 17.0013 32.9322 17.2825 32.9322 17.2825V20.4564H31.285C29.678 20.4564 29.1959 21.4206 29.1959 22.4652V24.8757H32.7715L32.209 28.5719Z",
    fill: "#648586"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSocialAccess);
export default __webpack_public_path__ + "static/media/Button_Social_Access.ff8745cb7e0588c5a829e15a0bba700f.svg";
export { ForwardRef as ReactComponent };